<template>
  <div class="label fvl">
    <div v-for="item in datas" :key="item.id" class="fc">
      <img :src="require(`@/assets/tagsImg/${item.icon}.png`)" alt="" />
      <!-- <span :style="{ color: item.color }">{{ item.name }}</span> -->
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'

export default {
  props: ['datas'],
  setup(props) {
    let { datas } = toRefs(props)
    const state = reactive({
      datas
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  font-size: 12px;
  margin-bottom: 12px;
  > div {
    margin-right: 18px;
  }
  img {
    margin-right: 3px;
    max-width: 12px;
    max-height: 12px;
  }
  span {
    color: #999;
  }
}
</style>
